import React from "react";
import TenantLogoSVG from "./assets/TenantLogo.svg";

export const TenantLogo = () => {
  return <TenantLogoSVG />;
};
